export enum AppointmentType {
  CALL = 'CALL',
  SITE_VISIT = 'SITE_VISIT',
  VIDEO = 'VIDEO',
  MEETING = 'MEETING',
  OTHER = 'OTHER',
  EMAIL = 'EMAIL',
  TASK = 'TASK',
}

export enum AppointmentStatus {
  SCHEDULED = 'SCHEDULED',
  DONE = 'DONE',
  CANCELED = 'CANCELED',
}

export interface Reminder {
  minutesBefore: number;
  channel: 'in_app' | 'email';
}

export interface Appointment {
  _id: string;
  dealId: string;
  dealName?: string;
  contactId?: string;
  contactName?: string;
  organizerUserId: string;
  organizerName?: string;
  participantUserIds: string[];
  participants?: Array<{ _id: string; name: string }>;
  title: string;
  description?: string;
  location?: string;
  type: AppointmentType;
  start: Date | string;
  end: Date | string;
  timezone: string;
  allDay: boolean;
  status: AppointmentStatus;
  reminders: Reminder[];
  videoConferenceLink?: string;
  createdAt: Date | string;
  updatedAt: Date | string;
}

export interface CreateAppointmentDto {
  dealId: string;
  contactId?: string;
  participantUserIds: string[];
  title: string;
  description?: string;
  location?: string;
  type: AppointmentType;
  start: string;
  end: string;
  timezone: string;
  allDay: boolean;
  reminders?: Reminder[];
  videoConferenceLink?: string;
}

export interface UpdateAppointmentDto extends Partial<CreateAppointmentDto> {
  status?: AppointmentStatus;
}
